import { render, staticRenderFns } from "./InputFirstName.vue?vue&type=template&id=052a8e95&"
import script from "./InputFirstName.vue?vue&type=script&lang=js&"
export * from "./InputFirstName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports